// import React from "react";
// import { Link } from "react-router-dom";

// const SideBanners = ({ homeSideBanners }) => {
//   return (
//     <div className="sticky">
//       {homeSideBanners?.length !== 0 &&
//         homeSideBanners?.map((item, index) => (
//           <div className="banner mb-3" key={index}>
//             {item?.subCatId !== null ? (
//               <Link
//                 to={`/products/subCat/${item?.subCatId}`}
//                 className="box"
//               >
//                 <img
//                   src={item?.images[0]}
//                   className="w-100 transition"
//                   alt="banner img"
//                 />
//               </Link>
//             ) : (
//               <Link
//                 to={`/products/category/${item?.catId}`}
//                 className="box"
//               >
//                 <img
//                   src={item?.images[0]}
//                   className="cursor w-100 transition"
//                   alt="banner img"
//                 />
//               </Link>
//             )}
//           </div>
//         ))}
//     </div>
//   );
// };

// export default SideBanners;


import React from "react";
import { Link } from "react-router-dom";

// Skeleton Loader Component
// const SkeletonSideBannerItem = () => (
//   <div className="banner mb-3 skeleton-loader">
//     <div className="box">
//       <div className="skeleton-image"></div>
//     </div>
//   </div>
// );
const SkeletonSideBannerItem = () => (
  <div className="productItem bg-gray-200 rounded-lg w-[246px] h-[331px] m-2.5 overflow-hidden relative">
    {/* Skeleton for the Image */}
    <div className="w-full h-[250px] bg-gray-300 rounded-t-lg animate-pulse"></div>
    
    {/* Shimmer Effect */}
    <div
      className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-75"
      style={{
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
      }}
    ></div>
  </div>
  
);

const SideBanners = ({ homeSideBanners,isLoading }) => {
  return (
    <div className="sticky">
      {!isLoading && homeSideBanners?.length !== 0 ? (
        homeSideBanners?.map((item, index) => (
          <div className="banner mb-3" key={index}>
            {item?.subCatId !== null ? (
              <Link
                to={`/products/subCat/${item?.subCatId}`}
                className="box"
              >
                <img
                  src={item?.images[0]}
                  className="w-100 transition"
                  alt="banner img"
                />
              </Link>
            ) : (
              <Link
                to={`/products/category/${item?.catId}`}
                className="box"
              >
                <img
                  src={item?.images[0]}
                  className="cursor w-100 transition"
                  alt="banner img"
                />
              </Link>
            )}
          </div>
        ))
      ) : (
        // Display Skeleton Loader when data is empty or loading
        Array(2)
          .fill(0)
          .map((_, index) => (
            <SkeletonSideBannerItem key={index} />
          ))
      )}
    </div>
  );
};

// CSS for Skeleton Loader and Animation (Add this style directly to the component file using 'style' tag)
const style = `
  .skeleton-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .skeleton-image {
    background-color: #ccc;
    width: 100%;
    height: 100%;
    animation: skeleton-loading 1.5s infinite ease-in-out;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: #ccc;
    }
    50% {
      background-color: #ddd;
    }
    100% {
      background-color: #ccc;
    }
  }
`;

// Append the style dynamically to the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = style;
document.head.appendChild(styleSheet);

export default SideBanners;
